/**
 * Account Type / Role selection component
 */
import { Camera, Briefcase } from "lucide-react";
import { Card } from "@/components/ui/card";
import CheckBox from "./CheckBox";

export function RoleSelector({ roleAssistant, setRoleAssistant, roleStudio, setRoleStudio }) {
  return (
    <Card className="bg-white/[0.03] border-white/5 p-8 mb-6">
      <h2 className="text-xl font-semibold mb-2">Account Type</h2>
      <p className="text-white/50 mb-6">Select how you want to use GottaSecond (you can be both)</p>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div 
          className={`flex items-center gap-4 p-4 bg-white/[0.05] border rounded-sm cursor-pointer transition-all ${roleAssistant ? "border-white/40 bg-white/5" : "border-white/10"}`}
          onClick={() => setRoleAssistant(!roleAssistant)}
          data-testid="role-assistant-toggle"
        >
          <CheckBox checked={roleAssistant} />
          <Camera className="w-5 h-5 text-white/60" />
          <div className="flex-1">
            <span className="font-medium">Find Work</span>
            <p className="text-white/50 text-sm">Browse jobs & get hired as second shooter</p>
          </div>
        </div>
        
        <div 
          className={`flex items-center gap-4 p-4 bg-white/[0.05] border rounded-sm cursor-pointer transition-all ${roleStudio ? "border-white/40 bg-white/5" : "border-white/10"}`}
          onClick={() => setRoleStudio(!roleStudio)}
          data-testid="role-studio-toggle"
        >
          <CheckBox checked={roleStudio} />
          <Briefcase className="w-5 h-5 text-white/60" />
          <div className="flex-1">
            <span className="font-medium">Hire Talent</span>
            <p className="text-white/50 text-sm">Post jobs & find second shooters</p>
          </div>
        </div>
      </div>
    </Card>
  );
}

export default RoleSelector;
